import { useSelector } from 'react-redux';
import useHover from 'common/utils/hooks/useHover';
import { selectIsNavBarCollapsed } from 'features/loggedInRoutesPanel/slice';
import { useTicketPermissions } from 'remote-state/ticketServiceHooks';
import { StyledNavbar, StyledScrollBar, StyledDivider } from './style';
import ToggleButton from '../toggleButton';
import NavHeader from './navHeader';
import NewTicket from './newTicket';
import NavSearch from './navSearch';
import NavList from './navList/index';
import NavFooter from './navFooter';

export default function NavigationBar(props) {
  const { toggleNavBarCollapse } = props;
  const [hoverRef, isHovered] = useHover();
  const navBarCollapsed = useSelector(selectIsNavBarCollapsed);
  const renderView = ({ style, ...props }) => <div {...props} style={style} />;
  const { data: hasEditPermissions } = useTicketPermissions('create', 1);
  return (
    <StyledNavbar
      data-testid="nav-bar"
      data-cy="nav-bar"
      id="nav-bar"
      ref={hoverRef}
      className={navBarCollapsed ? 'collapsed' : 'expanded'}
    >
      <ToggleButton
        data-testid="nav-bar-toggle-button"
        data-cy="nav-bar-toggle-button"
        toggle={toggleNavBarCollapse}
        leftChevron={!navBarCollapsed}
        isDisplay={isHovered}
      />
      <NavHeader navBarCollapsed={navBarCollapsed} />
      <StyledDivider />
      {hasEditPermissions && <NewTicket expanded={!navBarCollapsed} />}
      <NavSearch expanded={!navBarCollapsed} />
      <StyledScrollBar
        renderView={renderView}
        sx={{ marginBottom: 0 }}
        autoHide={false}
        dataset={{ 'data-testid': 'nav-bar-scrollbar', 'data-cy': 'nav-bar-scrollbar' }}
      >
        <NavList expanded={!navBarCollapsed} />
      </StyledScrollBar>
      <NavFooter expanded={!navBarCollapsed} />
    </StyledNavbar>
  );
}
